export class MercerSupportPositionClassHelper {
  public static readonly seniorManagementPositionClassStart = 59;
  /** Lowest position class that makes a German request a fully evaluated one (TRAVO). */
  public static readonly germanFullEvaluationPositionClassStart = 55;
  public static readonly minPositionClass = 40;
  public static readonly maxPositionClass = 80;
  public static readonly isoCodeDE = 'DE';
}
